const STORAGE_KEY = 'kisapuk-analytics';
const SESSION_KEY = 'kisapuk-analytics-session';

interface AnalyticsStore {
  totalVisits: number;
  daily: Record<string, number>;
  monthly: Record<string, number>;
}

function getTodayKey(date = new Date()): string {
  return date.toISOString().slice(0, 10);
}

function getMonthKey(date = new Date()): string {
  return date.toISOString().slice(0, 7);
}

function readStore(): AnalyticsStore {
  if (typeof window === 'undefined') {
    return { totalVisits: 0, daily: {}, monthly: {} };
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { totalVisits: 0, daily: {}, monthly: {} };
    }
    const parsed = JSON.parse(raw) as AnalyticsStore;
    return {
      totalVisits: parsed.totalVisits || 0,
      daily: parsed.daily || {},
      monthly: parsed.monthly || {},
    };
  } catch {
    return { totalVisits: 0, daily: {}, monthly: {} };
  }
}

function writeStore(store: AnalyticsStore) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
}

export function trackVisit() {
  if (typeof window === 'undefined') return;
  if (window.sessionStorage.getItem(SESSION_KEY)) return;

  const store = readStore();
  const todayKey = getTodayKey();
  const monthKey = getMonthKey();

  store.totalVisits += 1;
  store.daily[todayKey] = (store.daily[todayKey] || 0) + 1;
  store.monthly[monthKey] = (store.monthly[monthKey] || 0) + 1;

  writeStore(store);
  window.sessionStorage.setItem(SESSION_KEY, '1');
}

export function getTrafficSnapshot() {
  const store = readStore();
  const todayKey = getTodayKey();
  const monthKey = getMonthKey();

  const dailyEntries = Object.entries(store.daily)
    .sort(([a], [b]) => a.localeCompare(b))
    .slice(-7)
    .map(([day, count]) => ({
      day: day.slice(5),
      count,
    }));

  const monthlyEntries = Object.entries(store.monthly)
    .sort(([a], [b]) => a.localeCompare(b))
    .slice(-6)
    .map(([month, count]) => ({
      month: month.slice(5),
      count,
    }));

  return {
    totalVisits: store.totalVisits,
    dailyVisits: store.daily[todayKey] || 0,
    monthlyVisits: store.monthly[monthKey] || 0,
    dailyTrend: dailyEntries,
    monthlyTrend: monthlyEntries,
  };
}
